module.exports = __webpack_public_path__ + "img/p_15.7057dffd.png";